export default "__VITE_ASSET__CtYcUshw__"